<template>
    <section class="session-search-context-menu"
             role="menu"
             :aria-label="$t('com.file.meeting-actions.menu')"
             @keydown="onMenuKeydown">
        <!-- wiersze z entries (uklad z sessionViewMenuLayout.js), grupa z podmenu w bok albo akordeonem -->
        <!-- kopia 1/2 pozycji <a>/<router-link> (wiersze glownego poziomu); zmieniaj razem z kopia w podmenu grupy nizej -->
        <!-- Vue 3: klucz <template v-for> musi byc na <template>; regula vue/no-v-for-template-key z konfiguracji "essential" dotyczy Vue 2 -->
        <!-- eslint-disable-next-line vue/no-v-for-template-key -->
        <template v-for="entry in entries" :key="entry.key">
            <a v-if="entry.type === 'action' && entry.action.getUrl"
               :href="entry.action.getUrl(session)"
               target="_blank"
               rel="noopener noreferrer"
               class="session-search-context-menu__item" :class="{'borderline' : entry.borderline }"
               role="menuitem"
               tabindex="-1"
               @click="$emit('actionSelected')">
                <img :src="require(`@/assets/icons/meetingsActions/${entry.action.icon}.svg`)"
                     class="session-search-context-menu__item__icon" alt="" />
                <span class="session-search-context-menu__item__text">{{$t(entry.action.name)}}</span>
            </a>
            <router-link v-else-if="entry.type === 'action'"
                         :to="{name: entry.action.action, params: { sessionid: sessionId, groupid: groupId }}"
                         class="session-search-context-menu__item" :class="{'borderline' : entry.borderline }"
                         role="menuitem"
                         tabindex="-1"
                         @click.capture="onItemClickCapture($event, entry.action)"
                         @click="onItemClick(entry.action)">
                <img :src="require(`@/assets/icons/meetingsActions/${entry.action.icon}.svg`)"
                     class="session-search-context-menu__item__icon" alt="" />
                <span class="session-search-context-menu__item__text">{{$t(entry.action.name)}}</span>
            </router-link>
            <div v-else
                 class="session-search-context-menu__group"
                 :class="{
                     'borderline': entry.borderline,
                     'session-search-context-menu__group--open': openGroupId === entry.id,
                     'session-search-context-menu__group--right': openGroupId === entry.id && submenuPlacement === 'right',
                     'session-search-context-menu__group--inline': openGroupId === entry.id && submenuPlacement === 'inline'
                 }"
                 role="none">
                <button type="button"
                        :id="toggleId(entry.id)"
                        class="session-search-context-menu__item session-search-context-menu__group-toggle"
                        role="menuitem"
                        aria-haspopup="menu"
                        :aria-expanded="openGroupId === entry.id ? 'true' : 'false'"
                        tabindex="-1"
                        @click="onGroupToggleClick($event, entry.id)">
                    <img :src="require(`@/assets/icons/meetingsActions/${entry.icon}.svg`)"
                         class="session-search-context-menu__item__icon" alt="" />
                    <span class="session-search-context-menu__item__text">{{$t(entry.name)}}</span>
                    <img src="@/assets/icons/components/calendar-chevron-left.svg"
                         class="session-search-context-menu__group-chevron" alt="" />
                </button>
                <div v-show="openGroupId === entry.id"
                     :id="submenuId(entry.id)"
                     class="session-search-context-menu__submenu"
                     :class="'session-search-context-menu__submenu--' + submenuPlacement"
                     :style="openGroupId === entry.id ? submenuStyle : null"
                     role="menu"
                     :aria-labelledby="toggleId(entry.id)"
                     @keydown="onSubmenuKeydown($event, entry.id)">
                    <!-- kopia 2/2 pozycji <a>/<router-link> (wiersze podmenu); zmieniaj razem z wierszami glownego poziomu wyzej; osobny komponent zgubilby scoped style ikon i tekstu -->
                    <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                    <template v-for="action in entry.actions" :key="'action-' + action.id">
                        <a v-if="action.getUrl"
                           :href="action.getUrl(session)"
                           target="_blank"
                           rel="noopener noreferrer"
                           class="session-search-context-menu__item"
                           role="menuitem"
                           tabindex="-1"
                           @click="$emit('actionSelected')">
                            <img :src="require(`@/assets/icons/meetingsActions/${action.icon}.svg`)"
                                 class="session-search-context-menu__item__icon" alt="" />
                            <span class="session-search-context-menu__item__text">{{$t(action.name)}}</span>
                        </a>
                        <router-link v-else
                                     :to="{name: action.action, params: { sessionid: sessionId, groupid: groupId }}"
                                     class="session-search-context-menu__item"
                                     role="menuitem"
                                     tabindex="-1"
                                     @click.capture="onItemClickCapture($event, action)"
                                     @click="onItemClick(action)">
                            <img :src="require(`@/assets/icons/meetingsActions/${action.icon}.svg`)"
                                 class="session-search-context-menu__item__icon" alt="" />
                            <span class="session-search-context-menu__item__text">{{$t(action.name)}}</span>
                        </router-link>
                    </template>
                </div>
            </div>
        </template>
    </section>
</template>
<script charset="utf-8">
    import { meetingsActions } from "@/componentsData/meetingsActions.js";
    import { buildMenuEntries } from "@/helpers/sessionMenuEntries.js";

    // ponizej tej szerokosci okna podmenu rozwija sie akordeonem (PRD 5.4)
    const INLINE_BREAKPOINT = 768;
    // ten sam warunek co @media (max-width: 767px) w stylach; innerWidth bywa wieksze, gdy strona jest szersza od okna
    const INLINE_MEDIA_QUERY = `(max-width: ${INLINE_BREAKPOINT - 1}px)`;

    function isNarrowViewport() {
        return window.matchMedia(INLINE_MEDIA_QUERY).matches;
    }
    // minimalny odstep podmenu od krawedzi okna
    const VIEWPORT_MARGIN = 8;
    const GROUP_CLASS = "session-search-context-menu__group";
    const GROUP_TOGGLE_CLASS = "session-search-context-menu__group-toggle";
    const ITEM_CLASS = "session-search-context-menu__item";

    // ostrzezenia w trybie deweloperskim tylko raz na id: akcja spoza ukladu, id z ukladu spoza katalogu
    const warnedFallbackIds = new Set();
    const warnedUnknownIds = new Set();
    let instanceCounter = 0;

    function warnOnce(warned, id, message) {
        if (!warned.has(id)) {
            warned.add(id);
            console.warn(message);
        }
    }

    export default {
        emits: ["actionSelected", "close"],
        name: "SessionSearchContextMenu",
        props: {
            sessionId: Number,
            groupId: Number,
            session: {
                type: Object,
                default: null
            },
            skippedActionId: {
                type: Array,
                default() {
                    return [];
                }
            },
            // uklad z sessionViewMenuLayout.js ({ mode, items }); null = menu bez wierszy
            // (widok posiedzenia, zanim policzy pominiete akcje)
            layout: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                openGroupId: null,
                // left, right albo inline (akordeon)
                submenuPlacement: "left",
                submenuStyle: null
            };
        },
        computed: {
            // widoczne akcje w kolejnosci katalogu; kolejnosc wierszy wynika z ukladu
            actions() {
                // akcje z getUrl (zewnetrzny adres) sa widoczne tylko, gdy adres da sie zbudowac
                // i aplikacja nie jest w trybie interaktywnym; liczone reaktywnie na kazde przeliczenie computed;
                // tryb interaktywny wskazuje store albo uklad (bezpieczniej ukryc w stanie przejsciowym z PRD 4.4)
                const isInInteractiveMode = this.$store.state.appStore.isInInteractiveMode || (this.layout && this.layout.mode === "interactive");
                return meetingsActions.filter(item => {
                    if (this.skippedActionId.indexOf(item.id) !== -1) {
                        return false;
                    }
                    if (typeof item.getUrl !== "function") {
                        return true;
                    }
                    if (isInInteractiveMode) {
                        return false;
                    }
                    return !!item.getUrl(this.session);
                });
            },
            entries() {
                if (!this.layout) {
                    return [];
                }
                const result = buildMenuEntries(this.layout.items || [], this.actions, meetingsActions);
                if (process.env.NODE_ENV !== "production") {
                    result.fallbackIds.forEach(id => {
                        warnOnce(warnedFallbackIds, id, `SessionSearchContextMenu: akcja ${id} nie ma miejsca w ukladzie menu, pokazana w miejscu "fallback"`);
                    });
                    result.unknownIds.forEach(id => {
                        warnOnce(warnedUnknownIds, id, `SessionSearchContextMenu: uklad menu wskazuje akcje ${id}, ktorej nie ma w meetingsActions.js`);
                    });
                }
                return result.entries;
            }
        },
        watch: {
            layout() {
                this.onStructureChange(true);
            },
            entries(newEntries) {
                // otwarta grupa zniknela albo splaszczyla sie do jednej akcji (PRD 4.4)
                const openGroupId = this.openGroupId;
                const groupStillOpen = openGroupId === null || newEntries.some(entry => entry.type === "group" && entry.id === openGroupId);
                this.onStructureChange(!groupStillOpen);
            }
        },
        created() {
            // pola bez reaktywnosci
            instanceCounter += 1;
            this.idPrefix = "session-search-context-menu-" + instanceCounter;
            this.focusRestorePending = false;
        },
        methods: {
            menuItemClickHanlder(item) {
                item.handler(this.sessionId);
                this.$emit("actionSelected");
            },

            // pozycje-komendy (action: "") nie nawiguja; capture biegnie przed navigate z RouterLink
            onItemClickCapture(event, action) {
                if (action.action !== "") {
                    return;
                }
                event.preventDefault();
                this.menuItemClickHanlder(action);
            },
            onItemClick(action) {
                if (action.action === "") {
                    return;
                }
                this.menuItemClickHanlder(action);
            },

            toggleId(groupId) {
                return this.idPrefix + "-group-" + groupId;
            },
            submenuId(groupId) {
                return this.idPrefix + "-submenu-" + groupId;
            },

            // publiczne: rodzic wola przy otwarciu i zamknieciu menu
            resetGroups() {
                this.closeGroup(false);
            },
            focusFirstItem() {
                this.$nextTick(() => {
                    const items = this.levelItems(this.$el);
                    if (items.length > 0) {
                        items[0].focus();
                    }
                });
            },

            openGroup(groupId, focusFirst) {
                if (this.openGroupId === groupId) {
                    if (focusFirst) {
                        this.$nextTick(() => {
                            this.focusFirstSubmenuItem(groupId);
                        });
                    }
                    return;
                }
                // przelaczenie z innej grupy: fokus nie moze zostac w ukrywanym podmenu
                if (this.openGroupId !== null) {
                    this.moveFocusOutOfSubmenu(this.openGroupId);
                }
                this.openGroupId = groupId;
                this.submenuPlacement = isNarrowViewport() ? "inline" : "left";
                this.submenuStyle = null;
                // pomiar dopiero po pokazaniu podmenu; fokus po wyrenderowaniu wyniku pomiaru
                this.$nextTick(() => {
                    this.placeSubmenu(groupId);
                    if (focusFirst) {
                        this.$nextTick(() => {
                            this.focusFirstSubmenuItem(groupId);
                        });
                    }
                });
            },
            // fokus z zamykanego podmenu wraca na wiersz jego grupy
            moveFocusOutOfSubmenu(groupId) {
                const submenu = document.getElementById(this.submenuId(groupId));
                if (submenu && submenu.contains(document.activeElement)) {
                    const toggle = document.getElementById(this.toggleId(groupId));
                    if (toggle) {
                        toggle.focus();
                    }
                }
            },
            // moveFocus = false: zamkniecie bez ruszania fokusu (reset z rodzica, menu ukryte)
            closeGroup(moveFocus = true) {
                if (moveFocus && this.openGroupId !== null) {
                    this.moveFocusOutOfSubmenu(this.openGroupId);
                }
                this.openGroupId = null;
                this.submenuPlacement = "left";
                this.submenuStyle = null;
            },
            placeSubmenu(groupId) {
                if (this.openGroupId !== groupId || this.submenuPlacement === "inline") {
                    return;
                }
                const submenu = document.getElementById(this.submenuId(groupId));
                if (!submenu) {
                    return;
                }
                const rect = submenu.getBoundingClientRect();
                if (rect.width === 0 && rect.height === 0) {
                    return;
                }

                // w poziomie: domyslnie w lewo, przy braku miejsca w prawo, gdy nigdzie sie nie miesci - akordeon
                let placement = "left";
                if (rect.left < VIEWPORT_MARGIN) {
                    const groupRect = submenu.parentElement.getBoundingClientRect();
                    const gap = groupRect.left - rect.right;
                    if (groupRect.right + gap + rect.width <= window.innerWidth - VIEWPORT_MARGIN) {
                        placement = "right";
                    }
                    else {
                        this.submenuPlacement = "inline";
                        return;
                    }
                }

                // w pionie: wyzsze niz okno dostaje wlasne przewijanie; pudelko podmenu dosuwane do przedzialu
                // [margines, wysokosc okna - margines]: wystajace w dol idzie w gore, wystajace u gory (wiersz grupy
                // czesciowo nad oknem) idzie w dol
                const viewportHeight = window.innerHeight;
                const style = {};
                let height = rect.height;
                if (height > viewportHeight - 2 * VIEWPORT_MARGIN) {
                    style.maxHeight = `calc(100vh - ${2 * VIEWPORT_MARGIN}px)`;
                    style.overflowY = "auto";
                    height = viewportHeight - 2 * VIEWPORT_MARGIN;
                }
                let targetTop = rect.top;
                if (targetTop + height > viewportHeight - VIEWPORT_MARGIN) {
                    targetTop = viewportHeight - VIEWPORT_MARGIN - height;
                }
                if (targetTop < VIEWPORT_MARGIN) {
                    targetTop = VIEWPORT_MARGIN;
                }
                const shift = targetTop - rect.top;
                if (shift !== 0) {
                    const top = parseFloat(window.getComputedStyle(submenu).top) || 0;
                    style.top = (top + shift) + "px";
                }
                this.submenuPlacement = placement;
                this.submenuStyle = Object.keys(style).length > 0 ? style : null;
            },
            focusFirstSubmenuItem(groupId) {
                if (this.openGroupId !== groupId) {
                    return;
                }
                const items = this.levelItems(document.getElementById(this.submenuId(groupId)));
                if (items.length > 0) {
                    items[0].focus();
                }
            },

            // podmenu otwiera tylko klikniecie (bez hover), ktore zawsze przelacza grupe;
            // Enter/Spacja przychodza tu jako click z detail === 0
            onGroupToggleClick(event, groupId) {
                if (this.openGroupId === groupId) {
                    this.closeGroup();
                    return;
                }
                this.openGroup(groupId, event.detail === 0);
            },

            // klawiatura wg APG menu (PRD 5.3); Enter i Spacja zostaja przy natywnym click
            levelItems(level) {
                const items = [];
                if (!level) {
                    return items;
                }
                Array.from(level.children).forEach(child => {
                    if (child.classList.contains(GROUP_CLASS)) {
                        const toggle = child.querySelector("." + GROUP_TOGGLE_CLASS);
                        if (toggle) {
                            items.push(toggle);
                        }
                    }
                    else if (child.classList.contains(ITEM_CLASS)) {
                        items.push(child);
                    }
                });
                return items;
            },
            nextIndex(key, index, count) {
                if (count === 0) {
                    return -1;
                }
                if (key === "ArrowDown") {
                    return index < 0 ? 0 : (index + 1) % count;
                }
                if (key === "ArrowUp") {
                    return index < 0 ? count - 1 : (index - 1 + count) % count;
                }
                if (key === "Home") {
                    return 0;
                }
                if (key === "End") {
                    return count - 1;
                }
                return -1;
            },
            // Spacja na linku (<a>, router-link) nie daje natywnego click jak na przycisku; przycisk grupy zostaje przy natywnym.
            // Powtorzenia klawisza tylko blokujemy, zeby nie wykonac akcji drugi raz.
            activateLinkOnSpace(event) {
                if (event.key !== " " || !event.target || event.target.tagName !== "A") {
                    return false;
                }
                event.preventDefault();
                if (!event.repeat) {
                    event.target.click();
                }
                return true;
            },
            onMenuKeydown(event) {
                if (event.key === "Tab") {
                    // bez preventDefault: fokus idzie naturalnie dalej albo wstecz
                    this.$emit("close", { returnFocus: false });
                    return;
                }
                if (event.altKey || event.ctrlKey || event.metaKey) {
                    return;
                }
                if (this.activateLinkOnSpace(event)) {
                    return;
                }
                if (event.key === "Escape") {
                    event.preventDefault();
                    this.$emit("close", { returnFocus: true });
                    return;
                }
                const items = this.levelItems(this.$el);
                const index = items.indexOf(event.target);
                if (event.key === "ArrowRight") {
                    const entry = index >= 0 ? this.entries[index] : null;
                    if (entry && entry.type === "group") {
                        event.preventDefault();
                        this.openGroup(entry.id, true);
                    }
                    return;
                }
                const next = this.nextIndex(event.key, index, items.length);
                if (next === -1) {
                    return;
                }
                event.preventDefault();
                if (this.openGroupId !== null) {
                    this.closeGroup();
                }
                items[next].focus();
            },
            onSubmenuKeydown(event, groupId) {
                if (event.altKey || event.ctrlKey || event.metaKey) {
                    return;
                }
                if (this.activateLinkOnSpace(event)) {
                    event.stopPropagation();
                    return;
                }
                if (event.key === "ArrowLeft" || event.key === "Escape") {
                    // zamyka tylko podmenu; glowny poziom nie dostaje tego klawisza
                    event.preventDefault();
                    event.stopPropagation();
                    this.closeGroup();
                    const toggle = document.getElementById(this.toggleId(groupId));
                    if (toggle) {
                        toggle.focus();
                    }
                    return;
                }
                const items = this.levelItems(event.currentTarget);
                const next = this.nextIndex(event.key, items.indexOf(event.target), items.length);
                if (next === -1) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                items[next].focus();
            },

            // stany przejsciowe (PRD 4.4): zamkniecie grupy i fokus na wiersz o tym samym indeksie
            topLevelIndexOf(element) {
                return this.levelItems(this.$el).findIndex(item => item.contains(element)
                    || (item.classList.contains(GROUP_TOGGLE_CLASS) && item.parentElement.contains(element)));
            },
            isRendered(element) {
                return element.getClientRects().length > 0;
            },
            onStructureChange(closeOpenGroup) {
                const root = this.$el;
                if (!root || !this.isRendered(root)) {
                    // menu ukryte: tylko zamkniecie grupy, bez fokusu i bez sprawdzania po renderze
                    this.closeGroup(false);
                    return;
                }
                const active = document.activeElement;
                const focusInside = !!active && active !== root && root.contains(active);
                const index = focusInside ? this.topLevelIndexOf(active) : -1;
                if (closeOpenGroup) {
                    this.closeGroup();
                }
                if (this.focusRestorePending) {
                    return;
                }
                // sprawdzenie po przerenderowaniu wierszy
                this.focusRestorePending = true;
                this.$nextTick(() => {
                    this.focusRestorePending = false;
                    this.restoreFocus(focusInside, index);
                });
            },
            restoreFocus(focusInside, index) {
                const root = this.$el;
                if (!root || !this.isRendered(root)) {
                    return;
                }
                const items = this.levelItems(root);
                if (items.length === 0) {
                    // puste otwarte menu sie zamyka
                    this.$emit("close", { returnFocus: focusInside });
                    return;
                }
                if (!focusInside) {
                    return;
                }
                const current = document.activeElement;
                if (current && current !== root && root.contains(current) && this.isRendered(current)) {
                    return;
                }
                items[Math.min(Math.max(index, 0), items.length - 1)].focus();
            }
        }
    }
</script>
<style lang="scss" scoped>

    .borderline {
        border-top: 1px solid rgb(217, 217, 217);
    }

    .session-search-context-menu {
        padding: 12px 0px;
        position: absolute;
        z-index: 128;
        background-color: white;
        border-radius: 12px;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 16px 32px 48px rgba(0, 8, 44, 0.12);
        display: none;

        &__item {
            padding: 12px 24px;
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            

            &__icon {
                width: 20px;
                height: 20px;
            }

            &__text {
                margin-left: 12px;
                font-weight: 500;
                font-size: 14px;
                line-height: 132%;
                color: #00082c;

                &--red {
                    color: #d80418;
                }
            }

            &:hover {
                background: rgba(0, 0, 0, 0.2);
            }
        }
    }

    // grupy i podmenu (tylko przy podanym ukladzie, PRD 5.4 i 6.4)
    .session-search-context-menu__group {
        position: relative;
    }

    // reset przycisku grupy; specyficznosc wyzsza niz globalne style przyciskow (bootstrap, CSS klienta)
    .session-search-context-menu .session-search-context-menu__group-toggle {
        width: 100%;
        border: 0;
        border-radius: 0;
        background: none;
        font: inherit;
        text-align: left;
        color: inherit;
        box-shadow: none;
        margin: 0;
        appearance: none;
    }

    .session-search-context-menu .session-search-context-menu__group-toggle:hover,
    .session-search-context-menu .session-search-context-menu__group--open > .session-search-context-menu__group-toggle {
        background: rgba(0, 0, 0, 0.2);
    }

    // odstep na etykiecie, nie na strzalce: padding na obrazku przesuwa os obrotu
    .session-search-context-menu__group-toggle .session-search-context-menu__item__text {
        margin-right: 16px;
    }

    .session-search-context-menu__group-chevron {
        width: 12px;
        height: 12px;
        margin-left: auto;
        flex: 0 0 12px;
        opacity: 0.9;
    }

    .session-search-context-menu__submenu {
        position: absolute;
        top: -12px;
        right: calc(100% + 4px);
        z-index: 129;
        box-sizing: border-box;
        width: max-content;
        max-width: 360px;
        padding: 12px 0px;
        background-color: white;
        border-radius: 12px;
        border: 1px solid #dce4ee;
        box-shadow: 16px 32px 48px rgba(0, 8, 44, 0.12);

        .session-search-context-menu__item__icon {
            flex: 0 0 20px;
        }

        &--right {
            right: auto;
            left: calc(100% + 4px);
        }

        // akordeon: podmenu w miejscu pod wierszem grupy, z wcieciem
        &--inline {
            position: static;
            width: auto;
            max-width: none;
            padding: 0px;
            border: 0;
            border-radius: 0;
            box-shadow: none;
            background-color: #f6f8fb;

            .session-search-context-menu__item {
                padding-left: 56px;
            }
        }
    }

    // strzalka wskazuje strone otwierania: w lewo, w prawo, w akordeonie w dol (zamkniete) i w gore (otwarte)
    @media (max-width: 767px) {
        .session-search-context-menu__group-chevron {
            transform: rotate(-90deg);
        }
    }

    .session-search-context-menu__group--right .session-search-context-menu__group-chevron {
        transform: rotate(180deg);
    }

    .session-search-context-menu__group--inline .session-search-context-menu__group-chevron {
        transform: rotate(90deg);
    }
</style>